import { Component, Input, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';

import { ChartDataset, ChartOptions, ChartType, Color } from 'chart.js';

import { RunInfo } from '../../interfaces/run.interface';
import { Racer } from '../../interfaces/racer.interface';


@Component({
  selector: 'app-lap-chart',
  templateUrl: './lap-chart.component.html',
  styleUrls: [ ]
})
export class LapChartComponent {

  // tslint:disable-next-line: variable-name
  private _colorLines = ['#EE3E34', '#1D4F9C', '#F09243', '#54B948', '#BDA0CC', '#EEC3D0', '#772120', '#221F1F', '#FDE92B', '#FFE1BA' ];

  // tslint:disable-next-line: variable-name
  private _run: RunInfo;

  @Input() set run( r: RunInfo ) {

    console.log( 'Runinfo: ',r );

    this._run = null;
    if ( r && r.results ) {
      this._run = r;
      this.setChartInfo( r );
    }

  }

  get run(): RunInfo {
    return this._run;
  }

  public chartData: ChartDataset[] = [];

  public chartLabels: string[] = [];

  public chartOptions: (ChartOptions) = {
    elements: {
      line: {
        tension: 0.1,
      }
    },
    responsive: true,
    scales: {
      A: 
        {
          position: 'left',
          min: 0,
          reverse: true,
          ticks: {
            color: 'gray',
            font: {
              size: 14,
            },
            stepSize: 1,
            autoSkip: false,
            callback: ( value, index, values ) => {
              if ( ( index === 0 ) || ( index === (values.length - 1) )) {
                return '';
              }
              if ( this.run ) {
                const name = this.getRacerAlias( this.getRacerGrid( this.run.results.classification.length - index ) );
                return `${ name } - ${ this.run.results.classification.length - index + 1 }`;
              } else {
                return '';
              }
            }
          },
        },
      B:
        {
          position: 'right',
          grid: {
            color: 'rgba(0,0,255,0.3)',
          },
          min: 0,
          reverse: true,
          ticks: {
            color: 'gray',
            font: {
              size: 14,
            },
            stepSize: 1,
            precision: 0,
            autoSkip: false,
            callback: ( value, index, values ) => {
              // console.log('B: callback', value, index, values );
              // console.log('chartOptions: ', this.chartOptions);
              if ( ( index === 0 ) || ( index === (values.length - 1) )) {
                return '';
              }
              if ( this.run ) {
                // const name = this.getRacerAlias( ( index <= this.run.results.classification.length ) ? this.run.results.classification[ index - 1 ].racerInfo : null );
                const name = this.getRacerAlias( ( index <= this.run.results.classification.length ) ? this.run.results.classification[ this.run.results.classification.length - index ].racerInfo : null );
                return `${ this.run.results.classification.length - index + 1 } - ${ name }`;
              } else {
                return '';
              }
            }
          }
        }
    },
  };

  public chartLegend = false;
  public chartType: ChartType = 'line';

  @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;

  constructor() { }

  getRacerAlias( r: Racer ): string {

    if ( r ) {
      return r.alias ? r.alias : r.name;
    }
    return '';

  }

  getRacerGrid( index: number ): Racer {
    if ( index >= this.run.results.grid.length ) {
      return null;
    }

    const racerId = this.run.results.grid[ index ];
    const racer = this.run.results.classification.find( r => racerId === r.racerid );
    if ( racer ) {
      return racer.racerInfo;
    }

    return null;
  }

  getRacerStartPosition( racerId: number ): number {
    return this.run.results.grid.indexOf( racerId );
  }

  setChartLabels( r: RunInfo ): void {
    this.chartLabels = [ 'Grid' ];
    for ( let i = 1; i <= r.results.lapcount; i++ ) {
      this.chartLabels.push( `${ i.toString() }L`);
    }
  }

  setChartInfo( r: RunInfo ): void {

    this.chartData = [];

    this.setChartLabels( r );

    this.chartOptions.scales.A.max = r.results.classification.length + 1;
    this.chartOptions.scales.B.max = r.results.classification.length + 1;

    r.results.classification.forEach( ( racer, index ) => {

      const racerColor = this._colorLines[ index % this._colorLines.length ];

      const label = this.getRacerAlias( racer.racerInfo );
      const data = racer.laps.map( l => l.p );
      data.unshift( this.getRacerStartPosition( racer.racerid) + 1 );
      const serie = {
        label,
        data,
        yAxisID: 'B',


        color: racerColor,
        borderColor: racerColor,
        pointBackgroundColor: racerColor,
        pointColor: racerColor,
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        fill: false,


      };
      this.chartData.push( serie );
    });

    this.chartOptions = { ... this.chartOptions };
  }


}
